import common from '../common';
import Actor from '../physics/Actor';
import Trap from './Trap';

export default class CrusherTrap extends Trap {
	constructor(state, type) {
		super();

		this._floorbody = null;
		this._activated = state;
		this.links = [];
		this._linked = false;

		this._type = Actor.TILE;
		this._trapType = type;
		this._animSystem = null;
		this._clip = null;
		this._action = null;
		this._base = null;
		this._crusher = null;

		this._playing = false;
		this.init();
	}

	init() {
		this._base = common.assets.model('tile_001');
		const matCopy = new THREE.MeshBasicMaterial({
			map: common.assets.texture(common.levelSettings.floortexture)
		});

		this._base.material = matCopy;
		this.add(this._base);

		const crusherObj = common.assets.anim('lab_crusher_crushanim');
		this._crusher = crusherObj.scene;

		this._clip = crusherObj.animations[0];
		this._animSystem = new THREE.AnimationMixer(this._crusher);
		this._action = this._animSystem.clipAction(this._clip);

		if (this._activated) {
			this._action.play();
		}

		this._crusher.position.y += 0.15;
		this.add(this._crusher);
	}

	destroy() {
		this._base.material.dispose();
		this._base.geometry.dispose();

		this._crusher.material.dispose();
		this._crusher.geometry.dispose();

		super.destroy();
	}

	_getSize(mesh) {
		mesh.updateMatrixWorld(true);
		const bb = new THREE.Box3().setFromObject(mesh);
		const width = bb.max.x - bb.min.x;
		const height = bb.max.y - bb.min.y;
		const depth = bb.max.z - bb.min.z;

		return {
			width  : width,
			height : height,
			depth  : depth
		};
	}

	update() {
		this._animSystem.update(P3.Ticker.dt * this._animSystem.timeScale);
	}

	startAnim() {
		this._action.play();
	}

	stopAnim() {
		this._action.stop();
	}

	playOnce() {
		if (this._playing) {
			return;
		}
		this._playing = true;
		this._action.setLoop(THREE.LoopOnce, 1);
		this._action.play();

		P3.utils.delay(this._clip.duration, () => {
			this._action.setLoop(THREE.LoopRepeat, Infinity);
			this._action.stop();
			this._playing = false;
		}, this);
	}

	toggleCrusher(override) {
		this.stopAnim();
		this._activated = !this._activated;

		let ani = common.assets.anim(this._activated ? 'lab_crusher_crushanim' : 'lab_crusher_freezeanim');

		if (override !== undefined) {
			ani = common.assets.anim(override ? 'lab_crusher_crushanim' : 'lab_crusher_freezeanim');
			this._activated = override;
		}

		this._clip = ani.animations[0];
		this._action = this._animSystem.clipAction(this._clip);
		this._action.play();
	}

	/**
	 * Links two objects together. Either `o1` or `o2` should be a reference to this object. A link should be established for both objects simultaenously.
	 * @param {Actor} o1 The TO link
	 * @param {Actor} o2 The FROM link.
	 */
	addLink(sender, receiver) {
		this.links.push({sender: sender, receiver: receiver});
		this._linked = true;
	}

	activate(override) {
		this.toggleCrusher(override);
	}

	get activated() {
		return this._activated;
	}

	get type() {
		return this._type;
	}

	get trapType() {
		return this._trapType;
	}

	set activated(v) {
		this._activated = v;
	}

	set type(v) {
		this._type = v;
	}
}
